import { BiErrorAlt } from "react-icons/bi";
import { MdTransform } from "react-icons/md";
import { CardLinkButton } from "../../components/CardLinkButton";
import { useAuth } from "../../hooks/auth";
import { permissions } from "../../shared/Permissions";
import { useTranslation } from "react-i18next";

import { AiOutlineFileDone, AiOutlineFileSearch } from "react-icons/ai";
import * as S from "./styles";

export function Report() {
  const { hasPermission } = useAuth();
  const { t } = useTranslation();

  return (
    <S.ReportContainer>
      {hasPermission(permissions.report.duplicatedItems.view) && (
        <CardLinkButton
          href="/report/duplicated-items"
          title={t("duplicatedItems")}
          description={t("duplicatedItemsDescription")}
        >
          <MdTransform />
        </CardLinkButton>
      )}

      {hasPermission(permissions.report.orders.view) && (
        <CardLinkButton
          href="/report/orders"
          title={t("orders")}
          description={t("ordersDescription")}
        >
          <BiErrorAlt />
        </CardLinkButton>
      )}

      {hasPermission(permissions.report.explore.view) && (
        <CardLinkButton
          href="/report/dynamicReport"
          title={t("dynamicReport")}
          description={t("dynamicReportCardDescription")}
        >
          <AiOutlineFileSearch />
        </CardLinkButton>
      )}

      {hasPermission(permissions.report.exploreAccountingSales.view) && (
        <CardLinkButton
          href="/report/salesTaxReport"
          title={t("salesTaxReport")}
          description={t("salesTaxReportDescription")}
        >
          <AiOutlineFileDone />
        </CardLinkButton>
      )}
    </S.ReportContainer>
  );
}
